import { Component } from "@angular/core";

@Component({
  selector: 'ws-assignment-overview',
  templateUrl: './assignment-overview.component.html',
  styleUrls: ['./assignment-overview.component.scss']
})
export class AssignmentOverviewComponent {

  addNew() {
  }

  onAssignmentOpen(assignmentId: string) {
    /*this.appContext.context?.startApp('ws', 'assignment-editor', {
      type: 'Open',
      data: {
        uri: 'contents://assignments/' + assignmentId
      }
    });*/
  }

}
